module.exports = __webpack_public_path__ + "static/img/4009.ff68be6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/4009.png
// module id = 716
// module chunks = 0 1 12